import { render, staticRenderFns } from "./ConsumerSearch.vue?vue&type=template&id=4f4ccdfd"
import script from "./ConsumerSearch.vue?vue&type=script&lang=ts"
export * from "./ConsumerSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports